/* External */
import { useEffect, useRef, useState } from 'react';
import { useRouteMatch } from 'react-router-dom';
import platform from '../../utils/platform';

/* Utils */
import { Routes } from '../../utils/router';

const GENERAL_DELAY = Number.parseInt(
  import.meta.env.VITE_DELAY_TO_SHOW_LOST_CONNECTION,
  10,
);
const PLAYER_DELAY = Number.parseInt(
  import.meta.env.VITE_PLAYER_DELAY_TO_SHOW_LOST_CONNECTION,
  10,
);

export default function useShowDisconnectedMessageState(connectionStatus) {
  const [showDisconnectedMessage, setShowDisconnectedMessage] = useState(false);

  const matchPlayer = useRouteMatch(Routes.Private.Player);

  const timeoutRef = useRef(undefined);

  useEffect(() => {
    const isPlayer = !!matchPlayer;
    if (connectionStatus) {
      const { isConnected } = connectionStatus;
      const timeoutDisconnected = isPlayer ? PLAYER_DELAY : GENERAL_DELAY;
      const timeout = isConnected ? platform.msToWaitOnReconnection : timeoutDisconnected;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        timeoutRef.current = undefined;
        setShowDisconnectedMessage(!isConnected);
      }, timeout);
    }
  }, [connectionStatus, matchPlayer]);

  return { showDisconnectedMessage, setShowDisconnectedMessage };
}
